import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";

import styles from "./DeleteModal.module.scss";
import i18n from "i18n";
const DeleteLocationModal = ({ open, handleClose, handleCancel, handleConfirm, locationName, locationType}) => {
    const content = <div className={styles["delete-location-modal-content"]}>
        <div className={styles["delete-location-modal-title"]}>{i18n.t("deleting.information")}</div>
        <div className={styles["delete-location-modal-buttons"]}>
            <div onClick={handleCancel}>{i18n.t("stay")}</div>
            <div onClick={handleConfirm}>{i18n.t("delete.confirm").toUpperCase()}</div>
        </div>
    </div>
    return (
      <div className={styles["delete-location-modal-container"]}>
          <GenericModal  title={i18n.t("are.you.sure.detele") + ` ${locationType} "${locationName}"?`}
            open={open}
            content={content}
            handleClose={handleClose}></GenericModal>
      </div>
    );
}


export default DeleteLocationModal;